import { useState, useRef } from 'react'
import { Box, Typography, IconButton, Popper, Fade, Paper } from "@mui/material";
import CopyIcon from '../../img/copy.png';
import { colors } from '../../Theme/tokens';

export default function WalletAddress() {
    const [open, setOpen] = useState(false);
    const walletAddress = "3K9CKsePi...Df5NfQh7iK";
    const anchorRef = useRef(null);

    const copyToClipboard = async () => {
        try {
            await navigator.clipboard.writeText(walletAddress);
            setOpen(true);
            setTimeout(() => {
                setOpen(false)
            }, 3000)
        } catch (err) {
            
        }

    }
    return (
        <Box mt={2} sx={{ borderRadius: '18px', padding: '20px', display: 'flex', gap: '5px', backgroundColor: colors.background.infoPanel, flexDirection: 'column' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '5px', justifyContent: 'center' }}>
                <Typography variant='h4' sx={{ fontWeight: 400, color: colors.text.primary, lineHeight: '29px' }}>Wallet address</Typography>
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: '10px', }}>
                <Typography variant='h4' sx={{ fontWeight: 400, color: colors.neutral.outlinedText, lineHeight: '30px' }}>{walletAddress}</Typography>
                <Box ref={anchorRef} onClick={copyToClipboard} sx={{ display: 'flex', alignSelf: 'center', borderRadius: '30px', background: 'white', gap: '5px', height: '40px', padding: '0 10px' }}>
                    <IconButton ><Box component="img" src={CopyIcon} sx={{ width: '18px', height: '20px' }} /></IconButton>
                    <Typography sx={{ fontWeight: 500, fontSize: '16px', color: colors.text.secondary, letterSpacing: '5%', lineHeight: '25px', alignSelf: 'center' }}>Copy</Typography>
                </Box>

                <Popper style={{ zIndex: 100000 }} open={open} anchorEl={anchorRef.current} placement="bottom" transition>
                    {({ TransitionProps }) => (
                        <Fade {...TransitionProps} style={{ zIndex: 100000 }} >
                            <Paper sx={{ backgroundColor: 'black', color: 'white', padding: '5px', zIndex: 100000 }}>
                                <Typography variant="body1">Copied to clipboard</Typography>
                            </Paper>
                        </Fade>
                    )}
                </Popper>
            </Box>

        </Box>
    )
}